<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 16/12/2021
  -->

<template>
	<div class="card p-2 " :style="{'max-height': isLegendShown ? 'calc(80vh - 200px)' : 'initial', 'min-height': isLegendShown ? '14rem' : '2.8rem'}"
		 v-if="hasLegendItemsToShow">
		<div class="qw-row">
			<div class="layout-spacer"></div>
			<div>
				<qw-link-button @click="changeLegendVisibility">{{ hideLegendButtonTitle }}</qw-link-button>
			</div>
		</div>

		<div class="overflow-y"

			 :style="{'width': legendWidth}"
			 v-if="isLegendShown">

			<div id="legendContent" class="p-2">

				<div class="mb-4" v-if="familyConnectionsArray.length">
					<div class="bold mb-2">Family Relationships</div>
					<div class="qw-row">
						<LineTypeItemView
							class="col-6 font-size-2 px-1"
							:isViewOnly="true"
							v-for="(lineTypeWrapper, index) of familyConnectionsArray" :key="'line_type_' + index"
							:line-type-item="lineTypeWrapper.lineTypeItem"
							:title-prefix="showFamilyConnectionsCount ? lineTypeWrapper.count + 'x': ''"/>
					</div>
				</div>
				<div class="mb-4" v-if="emotionalConnectionsArray.length">
					<div class="bold mb-2">Emotional Relationships</div>
					<div class="qw-row">
						<LineTypeItemView
							class="col-6 font-size-2 px-1"
							:isViewOnly="true"
							v-for="(lineTypeWrapper, index) of emotionalConnectionsArray" :key="'line_type_' + index"
							:line-type-item="lineTypeWrapper.lineTypeItem"
							:title-prefix="showEmotionalConnectionsCount ? lineTypeWrapper.count + 'x' : ''"/>
					</div>
				</div>
				<div v-if="healthConditionItems.length">
					<div class="bold mb-2">Health Conditions</div>
					<div class="qw-row">
						<div v-for="(healthCondition, index) of healthConditionItems" :key="'health_' + index"
							 class="col-12" style="padding-left: 20px">
							<div class="qw-row">
								<div class="bullet-point font-size-7" :style="{color: healthCondition.color}"/>
								<div><span v-if="showHealthConditionsCount" class="">{{ healthCondition.count }}x</span>
									{{ healthCondition.title }}
								</div>
							</div>
						</div>
					</div>

				</div>
				<!--			<div>-->
				<!--				<div class="bold">Symbols</div>-->
				<!--				<div class="qw-row">-->
				<!--					<div v-for="(symbol, index) of symbolItems" :key="'symbol_' + index"-->
				<!--						 class="col-6">-->
				<!--						<img :src="symbol.src" class="shape-item">-->

				<!--					</div>-->
				<!--				</div>-->
				<!--			</div>-->
			</div>

		</div>

	</div>
</template>

<script>


import CyPropWatchingView
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/cyeditor-edit-elements/CyPropWatchingView.vue";
import LineTypeItemView
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/cyeditor-edit-elements/LineTypeItemView.vue";
import {
	findEmotionalLineTypeItemByLineType,
	findFamilyLineTypeItemByLineType,
} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/lib/cyeditor-edit-elements/LineTypeItem";
let html2canvasImport = () => import("html2canvas");

export default {
	name: "GenogramLegendView",
	components: {LineTypeItemView},
	extends: CyPropWatchingView,

	props: {
		legendWidth: String,
		legendInitialVisibility: {Boolean, default: true}
	},

	data() {
		return {
			isLegendShown: true,
			showEmotionalConnectionsCount: false,
			showFamilyConnectionsCount: false,
			showHealthConditionsCount: false,
			emotionalConnectionsArray: [],
			familyConnectionsArray: [],
			lineTypeItems: [],
			healthConditionItems: [],
			symbolItems: [],
		}
	},

	mounted() {
		this.isLegendShown = this.legendInitialVisibility
	},

	methods: {

		onCyReady() {
			this.cy.on("cyeditor.added cyeditor.remove cyeditor.data cyeditor.linetype", e => {
				this.recalculateLegend()
			})
			this.recalculateLegend()
		},

		recalculateLegend() {
			this.recalculateConnectionTypesLegend()
			this.recalculateHealthConditionsLegend()
			this.recalculateSymbolsLegend()
		},

		recalculateConnectionTypesLegend() {
			let edges = this.cy.edges()
			// console.log("recalculateConnectionTypesLegend: ", edges)
			let familyConnectionsArray = []
			let emotionalConnectionsArray = []
			for (let edge of edges) {
				let {lineSubType} = edge.data()
				this.setLineTypeItem(lineSubType, familyConnectionsArray, findFamilyLineTypeItemByLineType)
				this.setLineTypeItem(lineSubType, emotionalConnectionsArray, findEmotionalLineTypeItemByLineType)
			}
			familyConnectionsArray.forEach(item => {
				if (item.count > 1) {
					this.showFamilyConnectionsCount = true
				}
			})
			emotionalConnectionsArray.forEach(item => {
				if (item.count > 1) {
					this.showEmotionalConnectionsCount = true
				}
			})
			familyConnectionsArray.sort((l, r) => r.count - l.count)
			emotionalConnectionsArray.sort((l, r) => r.count - l.count)
			this.familyConnectionsArray = familyConnectionsArray
			this.emotionalConnectionsArray = emotionalConnectionsArray
		},

		setLineTypeItem(lineSubType, destArray, searchFunction) {
			let lineTypeItem = searchFunction(lineSubType)
			if (lineTypeItem){// && lineTypeItem !== straightLine) {
				let index = destArray.findIndex(item => item.lineTypeItem.lineType === lineTypeItem.lineType)
				if (index < 0) {
					let lineTypeItemWrapper = {count: 1, lineTypeItem}
					destArray.push(lineTypeItemWrapper)
				} else {
					destArray[index].count++
				}
			}

		},

		recalculateHealthConditionsLegend() {
			let nodes = this.cy.nodes()
			// console.log("recalculateHealthConditionsLegend: ", nodes)
			let healthConditionItems = []
			this.showHealthConditionsCount = false
			for (let node of nodes) {
				let {tags} = node.data()
				if (tags) {
					for (let tag of tags) {
						let index = healthConditionItems.findIndex(item => item.color === tag.color && item.title === tag.title)
						if (index < 0) {
							healthConditionItems.push({
								count: 1,
								color: tag.color,
								title: tag.title
							})
						} else {
							healthConditionItems[index].count++
							this.showHealthConditionsCount = true
						}
					}
				}
			}
			healthConditionItems.sort((l, r) => r.count - l.count)
			this.healthConditionItems = healthConditionItems

		},

		recalculateSymbolsLegend() {
			let nodes = this.cy.nodes()
			// console.log("recalculateSymbolsLegend: ", nodes)

		},

		changeLegendVisibility() {
			this.isLegendShown = !this.isLegendShown
			this.$emit('legendVisibilityChange', this.isLegendShown)
		},

		async requestSnapshot(){
			this.isLegendShown = true
			await this.$nextTickPromise()
			let container = document.getElementById('legendContent')
			let imgBase64
			if(container){
				let html2canvas = (await html2canvasImport()).default
				let canvas = await html2canvas(container, {scale: 2 * window.devicePixelRatio})
				imgBase64 = canvas.toDataURL("image/jpeg", 1);
			}
			console.log("legend requestSnapshot: ", imgBase64)
			return imgBase64
		}
	},

	computed: {
		hideLegendButtonTitle() {
			return this.isLegendShown ? "Hide Legend" : "Show Legend"
		},

		hasLegendItemsToShow() {
			return this.healthConditionItems.length || this.emotionalConnectionsArray.length || this.familyConnectionsArray.length
		}
	},
}
</script>

<style lang="scss">

</style>
